import { useEffect, useState } from "react";
import axios from "axios";
import Lenis from "lenis";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Manifesto } from "@/components/landing/Manifesto";
import { About } from "@/components/landing/About";
import { PromoBanner } from "@/components/landing/PromoBanner";
import { MusicPlayer } from "@/components/landing/MusicPlayer";
import { SocialProofToast } from "@/components/landing/SocialProofToast";
import { Products } from "@/components/landing/Products";
import { SocialProof } from "@/components/landing/SocialProof";
import { Footer } from "@/components/landing/Footer";
import { LeadPopup } from "@/components/landing/LeadPopup";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Landing() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08 });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    let autoStopped = false;
    const events = ["wheel", "touchstart", "pointerdown", "keydown"];
    const stopAuto = () => {
      if (!autoStopped) {
        autoStopped = true;
        lenis.scrollTo(window.scrollY, { immediate: true });
      }
      events.forEach((ev) => window.removeEventListener(ev, stopAuto));
    };
    events.forEach((ev) => window.addEventListener(ev, stopAuto, { passive: true }));

    const hash = window.location.hash?.slice(1);
    let hashTimer;
    if (hash) {
      autoStopped = true;
      hashTimer = setTimeout(() => {
        const el = document.getElementById(hash);
        if (el) lenis.scrollTo(el, { offset: -80 });
      }, 500);
    }
    const autoTimer = setTimeout(() => {
      if (!autoStopped) {
        lenis.scrollTo(document.body.scrollHeight, { duration: 90, easing: (t) => t });
      }
    }, 5000);

    axios
      .get(`${API}/products`)
      .then((res) => setProducts(res.data))
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));

    return () => {
      clearTimeout(autoTimer);
      if (hashTimer) clearTimeout(hashTimer);
      events.forEach((ev) => window.removeEventListener(ev, stopAuto));
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-[#FBF7EE] text-[#211B10] min-h-screen" data-testid="landing-page">
      <Nav />
      <Hero />
      <Marquee />
      <Manifesto />
      <About />
      <PromoBanner products={products} />
      <Products products={products} loading={loading} />
      <SocialProof />
      <Footer />
      <MusicPlayer />
      <SocialProofToast />
      <LeadPopup />
    </div>
  );
}
